<template>
  <admin-layout :sectionTitle="sectionTitle">
    <!--<div class="page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">Partner</h1>
        </div>

        <div class="col-sm-auto">
          <a class="btn btn-primary" :href="route('agencies.create')"> Aggiungi partner </a>
        </div>
      </div>
    </div>-->

    <div class="card">
      <div class="card-header">
        <div class="row justify-content-between align-items-center flex-grow-1">
          <div class="col-sm-6 col-md-4 mb-3 mb-sm-0">
            <form>
              <!-- Search -->
              <div class="input-group input-group-merge input-group-flush">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="tio-search"></i>
                  </div>
                </div>
                <input id="datatableSearch" type="search" class="form-control" placeholder="Cerca Partner" aria-label="cerca partner" />
              </div>
              <!-- End Search -->
            </form>
          </div>
          <div class="col-sm-auto">
            <a class="btn btn-primary" :href="route('agencies.create')"> Aggiungi partner </a>
          </div>
        </div>
      </div>

      <div class="table-responsive datatable-custom">
        <table id="datatable" class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
          <thead class="thead-light">
            <tr>
              <th>Rag. Sociale</th>
              <th>Nome</th>
              <th>Indirizzo</th>
              <th>Comune</th>
              <th>Associata a</th>
              <th>Stato</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="agency in $page.props.agencies.data" :key="agency.id">
              <td>
                <strong>{{ agency.company_name }}</strong>
              </td>
              <td>
                <strong>{{ agency.name }}</strong>
              </td>
              <td>{{ agency.address }} {{ agency.zip }}</td>
              <td>{{ agency.municipality }}</td>
              <td>
                <span v-if="agency.parent_id" v-text="agency.parent.name"></span>
                <span v-else>---</span>
              </td>
              <td>
                <span v-if="agency.user && agency.user.id"> <span class="legend-indicator bg-success"></span> Utente associato </span>
                <span v-else> <span class="legend-indicator"></span> Nessun utente associato </span>
              </td>
              <td class="actions">
                <a class="btn btn-sm p-0 btn-link" :href="route('agencies.edit', agency.id)">
                  <i class="tio-visible-outlined"></i>
                </a>
                <a class="btn btn-sm p-0 btn-link" @click="onDelete(agency)">
                  <i class="tio-delete"></i>
                </a>
                <a :href="route('impersonate.agency', agency.id)" class="btn btn-sm btn-link" v-if="agency.user">
                  <i class="tio-sign-in"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-footer">
        <div class="row justify-content-center justify-content-sm-between align-items-sm-center">
          <div class="col-sm mb-2 mb-sm-0">
            <div class="d-flex justify-content-center justify-content-sm-start align-items-center">
              <span class="text-secondary">{{ pagination.current_page * pagination.data.length }} di {{ pagination.total }} agenzie</span>
            </div>
          </div>

          <div v-if="pagination.per_page < pagination.total" class="col-sm-auto">
            <div class="d-flex justify-content-center justify-content-sm-end">
              <!-- Pagination -->
              <pagination :pagination="pagination" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Layouts/Partials/Pagination";

export default {
  components: {
    AdminLayout,
    Pagination
  },

  props: ['sectionTitle'],

  data() {
    return {
      pagination: this.$page.props.agencies,
      form: this.$inertia.form()
    };
  },

  methods: {
    onDelete(agency) {
      this.form.delete(route("agencies.destroy", agency.id), {
        onSuccess: () => {}
      });
    }
  }
};
</script>
